export default function() {
  $(document).ready(function() {

    var SIGNUP_URL = thinkwell.config.host + '/placement_tests/signup';

    $('body').on('submit', '#placement-test-form', function(e) {
      $.post(SIGNUP_URL, $(e.target).serializeArray());
    });

  });
}
